import gql from 'graphql-tag'

export interface ISendVerificationEmailResponse {
  sendVerificationEmail: {
    type: string
    message: string
  }
}

export interface ISendVerificationEmailVariables {
  email: string
  organisationId: number
}

export default gql`
  mutation ($email: EmailAddressWithTLD!, $organisationId: PositiveInt!) {
    sendVerificationEmail(email: $email, organisationId: $organisationId) {
      type
      message
    }
  }
`
